import Main from './Main.vue'

export default [{
  path: 'comitente/pregao/:id',
  name: 'comitente.pregao',
  component: Main
}
]



// WEBPACK FOOTER //
// ./src/app/website/pregao-comitente/routes.js